module.exports = __webpack_public_path__ + "img/Speaker=Michael Ioffe.99c1d8e0.png";